import React from 'react';

export default function Footer() {
    return (
        <div>

            <footer className="ftco-footer ftco-section"
                    style={{background: "url('./images/image_5.jpg')", backgroundSize: 'cover'}}>
                <div className="overlayy1"/>
                <div className="container" id="footerCont">
                    <div className="row mb-5">
                        <div className="col-md">
                            <div className="ftco-footer-widget mb-4">
                                <h2 className="" style={{fontSize: "20px"}}>Dream Home</h2>
                                <p className="font-weight-bold" style={{color: "#e7e7e7", fontSize: "18px",}}>Creating
                                    Real Value In <span className="text-success">Real Estate</span></p>
                                <ul className="ftco-footer-social list-unstyled mt-5">
                                    <li className="ftco-animate">
                                        <a href={"https://wa.me/+919041917502"} target='_blank'><span
                                            className="fa fa-whatsapp"/></a>
                                    </li>
                                    <li className="ftco-animate"><a
                                        href={"https://www.facebook.com/dreamhomecolonisers"} target='_blank'><span
                                        className="fa fa-facebook"/></a>
                                    </li>
                                    <li className="ftco-animate"><a href="test"><span
                                        className="fa fa-instagram"/></a></li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-md">
                            <div className="ftco-footer-widget mb-4">
                                <h2 className="" style={{fontSize: "20px"}}>Have A Question ?</h2>
                                <div className="block-23 mb-3">
                                    <ul>

                                        <li><span><span className="icon fa fa-book"
                                                        style={{fontSize: "18px"}}/><span style={{
                                            color: "#e7e7e7",
                                            fontSize: "18px"
                                        }}>Bookings Open, Call Now !</span></span></li>
                                        <li className="mb-0"><a href="test"><span className="icon fa fa-phone mb-0"
                                                                 style={{fontSize: "18px"}}/><span
                                            style={{color: "#e7e7e7", fontSize: "18px"}}>9814206896</span></a></li>
                                        <li className="mb-0"><a href="test"><span className="icon fa fa-phone mb-0"
                                                                 style={{fontSize: "18px"}}/><span
                                            style={{color: "#e7e7e7", fontSize: "18px"}}>9814206896</span></a></li>

                                        <li className="mb-0"><a href="test"><span className="icon fa fa-phone mb-0"
                                                                 style={{fontSize: "18px"}}/><span
                                            style={{color: "#e7e7e7", fontSize: "18px"}}>9872124578</span></a></li>
                                        <li className="mb-0"><a href="test"><span className="icon fa fa-phone mb-0"
                                                                 style={{fontSize: "18px"}}/><span
                                            style={{color: "#e7e7e7", fontSize: "18px"}}>9041917502</span></a></li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md">
                            <div className="ftco-footer-widget mb-4">
                                <h2 className="" style={{fontSize: "20px"}}>Address</h2>
                                <div className="block-23 mb-3">
                                    <ul>
                                        <li><span className="icon fa fa-map" style={{fontSize: "18px"}}/><span
                                            style={{color: "#e7e7e7", fontSize: "18px"}}>On McDonalds - Jamsher Highway, Near Sofi Pind, Jalandhar Cantt</span>
                                        </li>
                                        <li><a href="test"><span className="icon fa fa-envelope pr-4"
                                                                 style={{fontSize: "18px"}}/><span
                                            style={{color: "#e7e7e7", fontSize: "18px"}}>info@yourdomain.com</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}